import React from 'react';

import Checkbox from '../common/input/Checkbox.jsx';
import { Onboarding as Testimonial } from '../common/container/Testimonial.jsx';
import { withSubmission } from '../common/container/Form.jsx';
import { Container as LoadingContainer, Fullscreen as LoadingFull } from '../common/container/Loading.jsx';
import { BrandPackagePreview } from './Onboarding.jsx';
import TestimonialRepository from "../common/repository/Testimonial.jsx";
import { Onboarding as Input } from '../common/input/Text.jsx';
import { User } from '../common/repository/Type.jsx';
import Request from '../common/Request.jsx';
import { rebrandForEveryone } from '../common/publicCompany.ts';
import { termsOfServiceUrl } from '../onboarding/v2/legalLinks.ts';

function withClaimAction(WrappedComponent, routeSegment, testimonialType) {
    return function (props) {
        const [id, setId] = React.useState(undefined);
        React.useEffect(() => {
            setId(props.id);
        }, []);
        const [testimonial, setTestimonial] = React.useState(undefined);
        React.useEffect(() => {
            if (!testimonialType || !TestimonialRepository[testimonialType]) {
                return;
            }
            const keys = Object.keys(TestimonialRepository[testimonialType]);
            const index = Math.floor(Math.random() * keys.length);
            setTestimonial(TestimonialRepository[testimonialType][keys[index]]);
        }, []);
        const [loading, setLoading] = React.useState(true);
        const handleError = (jqXHR) => {
            setLoading(false);
            setMessage(jqXHR && jqXHR.responseJSON && jqXHR.responseJSON.Message || 'There was an error with your request. Please wait a moment and try again.')
        }
        const [data, setData] = React.useState(undefined);
        const [loginVisible, setLoginVisible] = React.useState(false);
        React.useEffect(() => {
            if (!id || !Artcloud.url.vendor.onboarding[routeSegment]) {
                return;
            }
            Artcloud.api.get(
                Artcloud.url.vendor.onboarding[routeSegment].get(id),
                undefined,
                (responseData) => {
                    setData(responseData);
                    setLoading(false);
                },
                (jqXHR) => {
                    handleError(jqXHR);
                    setLoginVisible(true);
                },
                [Request.header.apiKey()]
            )
        }, [id]);
        const [inventoryCount, setInventoryCount] = React.useState(undefined);
        const [message, setMessage] = React.useState(undefined);
        const [migrationModalVisible, setMigrationModalVisible] = React.useState(false);
        const [redirectUrl, setRedirectUrl] = React.useState(undefined);
        const [step, setStep] = React.useState('claim');
        const handleContinue = () => window.location = redirectUrl
        const handleMigrationComplete = () => {
            setMigrationModalVisible(false);
            setStep('brand');
        }
        const handleSubmit = (data, callback) => {
            if (!Artcloud.url.vendor.onboarding[routeSegment]) {
                return;
            }
            if (!data.Password || data.Password.length == 0) {
                return;
            }
            if (!data.HasAgreedToTerms) {
                setMessage('Please accept the terms of service.');
                return;
            }
            setMessage(undefined);
            setLoading(true);
            const postData = Request.appendUtmReferrer({ HasAgreedToTerms: data.HasAgreedToTerms, Password: data.Password });
            Artcloud.api.post(
                Artcloud.url.vendor.onboarding[routeSegment].post(id),
                postData,
                (responseData) => {
                    switch (testimonialType) {
                        case 'Artist':
                            Artcloud.fullstory.event('Artist Invite Accepted', {});
                            break;
                        case 'Gallery':
                            Artcloud.fullstory.event('Gallery Referral Accepted', {});
                            break;
                    }
                    Artcloud.auth.setSessionCookie(responseData.Session);
                    setInventoryCount(responseData.InventoryCount);
                    setRedirectUrl(responseData.RedirectUrl);
                    if (responseData.InventoryCount > 0) {
                        setMigrationModalVisible(true);
                    } else {
                        setStep('brand');
                    }
                    if (callback) {
                        callback(responseData);
                    }
                },
                handleError,
                [Request.header.apiKey()]
            );
        }
        return (
            <>
                {
                    step == 'claim' &&
                    <WrappedComponent
                        {...props}
                        data={data}
                        loading={loading}
                        message={message}
                        redirectUrl={redirectUrl}
                        testimonial={testimonial}
                        onContinue={handleContinue}
                        onError={handleError}
                        onSubmit={handleSubmit}>
                        {props.children}
                        {
                            loginVisible &&
                            <a className="btn" href={rebrandForEveryone() ? "/login" : "https://artcloud.com/login"} style={{ display: 'inline-block', marginTop: '30px' }}>
                                Login to your account
                            </a>
                        }
                    </WrappedComponent>
                }
                {
                    migrationModalVisible &&
                    <MigrationModal data={data} inventoryCount={inventoryCount} onContinue={handleMigrationComplete} />
                }
                {
                    step == 'brand' &&
                    <BrandPackagePreview
                        error={message}
                        lastStepDisplay=" ArtCloud"
                        user={{ BusinessName: data && data.BusinessName, Type: { Name: testimonialType } }}
                        onContinue={handleContinue}
                        onError={handleError} />
                }
            </>
        )
    }
}

function _Claim(props) {
    const data = props.data;
    return (
        <div className="wrapper--onboarding">
            <div className="grid--onboarding">
                <div className="brand">
                    <img className="logo" src="/assets/img/logos/header-mark-left.svg" />
                    <Testimonial source={props.testimonial} />
                </div>
                <div className="form-header">
                    <h1>Claim your account</h1>
                    {
                        data &&
                        data.Username &&
                        data.Username.length > 0 &&
                        <p>
                            Welcome to ArtCloud, {data.Username}!
                            {
                                data.Inviters &&
                                data.Inviters.length > 0 &&
                                <> {data.Inviters.join(', ')} has invited you to try ArtCloud, the most robust art gallery business software on the market.</>
                            }
                        </p>
                    }

                </div>
                <div className="form-body">
                    <ClaimForm
                        email={data && data.Email}
                        loading={props.loading}
                        message={props.message}
                        onSubmit={props.onSubmit} />
                    {props.children}
                </div>
            </div>
        </div>
    )
}
const Claim = withClaimAction(_Claim, 'claims', User.Gallery);

function _ArtistInvite(props) {
    const data = props.data;
    return (
        <div className="wrapper--onboarding">
            <div className="grid--onboarding" style={{ gridTemplateRows: '210px auto' }}>
                <div className="brand">
                    <img className="logo" src="/assets/img/logos/header-mark-left.svg" />
                    <Testimonial source={props.testimonial} />
                </div>
                <div className="form-header">
                    <h1>Accept your invite</h1>
                    {
                        data &&
                        data.Name &&
                        data.Name.length > 0 &&
                        <>
                            <p>
                                Welcome to ArtCloud, {data.Name}!
                                {
                                    data.Inviter &&
                                    data.Inviter.length > 0 &&
                                    <> {data.Inviter} has invited you to try ArtCloud, software that makes presenting and selling your work online seamless.</>
                                }
                            </p>
                            <br />
                            <p>Generate consignment contracts, track locations, send artwork records & photos directly to connected ArtCloud Galleries, who can then send artwork returns and sales notifications.</p>
                        </>
                    }

                </div>
                <div className="form-body">
                    <ClaimForm
                        email={data && data.Email}
                        loading={props.loading}
                        message={props.message}
                        onSubmit={props.onSubmit} />
                    {
                        data &&
                        data.Inventory &&
                        data.Inventory.length > 0 &&
                        <div className="inventory-cont">
                            {data.Inventory.map((d, i) => (
                                <a key={i} href={d.Url} target="_blank">
                                    <img src={d.ImageUrl} alt={d.Title} />
                                </a>
                            ))}
                        </div>
                    }
                    {props.children}
                </div>
            </div>
        </div>
    )
}
const ArtistInvite = withClaimAction(_ArtistInvite, 'artistInvites', User.Artist);

function _ClaimForm(props) {
    const handleChange = (name, value) => {
        switch (name) {
            case 'HasAgreedToTerms':
                props.onChange(name, !props.state.HasAgreedToTerms ? true : false)
                return;
        }
        props.onChange(name, value);
    }
    if (!props.email) {
        return null;
    }
    return (
        <>
            <div className="form-body__grid--boxes form-body__grid--boxes--2">
                <div className="input-wrapper">
                    <label>Email</label>
                    <Input
                        autoComplete="off"
                        disabled={true}
                        value={props.email} />
                </div>
                <div className="input-wrapper">
                    <label>Create Password</label>
                    <Input
                        name="Password"
                        required={true}
                        type="password"
                        value={props.state.Password}
                        onChange={props.onChange} />
                </div>
                {props.loading && <LoadingFull />}
            </div>
            <div className="form-body__footer gap--24">
                <Checkbox
                    display={<>Accept <a href={termsOfServiceUrl()} target="_blank">terms of service</a></>}
                    name="HasAgreedToTerms"
                    value={props.state.HasAgreedToTerms == true}
                    onChange={handleChange} />
                <button className="btn" type="submit">
                    Continue
                </button>
            </div>
        </>
    );
}
const ClaimForm = withSubmission(_ClaimForm);

function MigrationModal(props) {
    const [complete, setComplete] = React.useState(false);
    const [error, setError] = React.useState(undefined);
    const [inventory, setInventory] = React.useState([]);
    const [tryCount, setTryCount] = React.useState(0);
    const tryCountRef = React.useRef(undefined);
    tryCountRef.current = tryCount;

    const maxTryCount = 20;
    const maxInventoryCount = Math.min(props.inventoryCount, 6);
    const _checkInventoryCount = (data) => data && data.length >= maxInventoryCount
    const getInventoryData = () => {
        if (_checkInventoryCount(inventory)) {
            setComplete(true);
            return;
        }
        setTryCount(tryCountRef.current + 1);
        Artcloud.api.get(
            Artcloud.url.vendor.onboarding.inventory.get(),
            undefined,
            (inventoryResponseData) => {
                const next = () => {
                    if (tryCountRef.current >= maxTryCount) {
                        props.onContinue()
                        return;
                    }
                    setTimeout(getInventoryData, 250)
                }
                if (!inventoryResponseData.Data) {
                    next();
                    return;
                }
                setInventory(inventoryResponseData.Data);
                if (_checkInventoryCount(inventoryResponseData.Data)) {
                    setInventory(inventoryResponseData.Data.slice(0, maxInventoryCount))
                    setComplete(true);
                } else {
                    next();
                }
            },
            (jqXHR) => setError(jqXHR && jqXHR.responseJSON && jqXHR.responseJSON.Message || 'There was an error with your request. Please wait a moment and try again.'),
            [Request.header.apiKey()]
        );
    }
    React.useEffect(getInventoryData, []);

    const images = [];
    for (let i = 0; i < maxInventoryCount; i++) {
        if (i < inventory.length) {
            const d = inventory[i];
            images.push(<span key={i} className="loaded"><img src={d.Image && d.Image.MediumUrl} alt={d.Title} /></span>)
        } else {
            images.push(<span key={i} />)
        }
    }
    let buttonClassName = 'btn';
    if (!complete) {
        buttonClassName += ' btn-disabled';
    }
    return (
        <>
            <LoadingContainer className="inventory-migration-modal">
                <div className="cont-modal">
                    <h1>Hang tight!</h1>
                    <p>We're uploading your inventory{props.data && props.data.Inviter ? ` from ${props.data.Inviter}` : ''}. You will be able to use a sample of it to set up your brand in ArtCloud.</p>
                    <div className="inventory-cont">
                        {images}
                    </div>
                    <div className={buttonClassName} onClick={complete ? props.onContinue : undefined} >
                        <span>Set Up Your Brand</span>
                    </div>
                </div>
            </LoadingContainer>
            {
                error &&
                error.length > 0 &&
                <LoadingContainer style={{ opacity: '0.9' }} onClick={clearError}>
                    <div className="input-wrapper with-button" style={{ fontSize: '16px' }}>
                        {error}
                        <button onClick={() => setError(undefined)}>Close</button>
                    </div>
                </LoadingContainer>
            }
        </>
    )
}

export { ArtistInvite, Claim };